/* eslint-disable */
import TourProductsRepository from './TourProducts';

let TourProductsSortedRepository = TourProductsRepository.extend({
    strategies: {
        compare:function(fields, model1, model2) {
            var points1 = 0,
                points2 = 0,
                i,
                value1,
                value2,
                sign,
                field,
                fieldsLength = fields.length;

            for(i=fieldsLength-1; i>=0; i--) {
                sign = 1;

                field = fields[i];

                if(_.isArray(field)) {
                    value1 = field[0];
                    value2 = field[1];
                } else {
                    sign = field.dir ? field.dir : 1;

                    value1 = model1.get(field.field);
                    value2 = model2.get(field.field);
                }
                if(typeof value1 === 'string' || typeof value2 === 'string') {
                    var result = value1.localeCompare(value2);
                    if(result === 1){
                        points1 += 1<<i;
                    } else {
                        if(result !== 0){
                            points2 += 1<<i;
                        }
                    }
                } else {
                    if(value1*sign > value2*sign) {
                        points1 += 1<<i;
                        break;
                    } else {
                        if(value1*sign != value2*sign) {
                            points2 += 1<<i;
                            break;
                        }
                    }
                }
            }

            return points1 > points2 ? 1 : (points1 == points2 ? 0 : -1);
        },
        none: function() {
            return 0;
        },
        identity:function(model1, model2, selectedIdentity) {
            var identity1 = model1.get('id'),
                identity2 = model2.get('id'),
                price1 = model1.get('tour').get('priceWithOilTax'),
                price2 = model2.get('tour').get('priceWithOilTax');

            identity1 = identity1 == selectedIdentity ? 0 : 1;
            identity2 = identity2 == selectedIdentity ? 0 : 1;

            return this.compare([[price1, price2], [identity1, identity2]], model1, model2);
        },
        priceUp: function(model1, model2) {

            var price1 = model1.get('tour').get('priceWithOilTax'),
                price2 = model2.get('tour').get('priceWithOilTax');

            return this.compare([[price1, price2]], model1, model2);
        },
        priceDown: function(model1, model2) {
            var price1 = model1.get('tour').get('priceWithOilTax'),
                price2 = model2.get('tour').get('priceWithOilTax');

            return this.compare([[-price1, -price2]], model1, model2);
        },
        nightUp: function(model1, model2) {
            var night1 = parseInt(model1.get('tour').get('nights')),
                night2 = parseInt(model2.get('tour').get('nights'));
            return this.compare([[night1, night2]], model1, model2);
        },
        nightDown: function(model1, model2) {
            var night1 = parseInt(model1.get('tour').get('nights')),
                night2 = parseInt(model2.get('tour').get('nights'));
            return this.compare([[-night1, -night2]], model1, model2);
        },
        dateUp: function(model1, model2) {
                var price1 = model1.get('tour').get('priceWithOilTax'),
                    price2 = model2.get('tour').get('priceWithOilTax');

            return this.compare([[price1, price2], {field:'dateFrom'}], model1, model2);
        },
        dateDown: function(model1, model2) {
            var price1 = model1.get('tour').get('priceWithOilTax'),
                price2 = model2.get('tour').get('priceWithOilTax');

            return this.compare([[price1, price2], {field:'dateFrom', dir:-1}], model1, model2);
        },
        hotUp: function(model1, model2) {
            var tour1 = model1.get('tour'),
                tour2 = model2.get('tour'),
                discount1 =  tour1.get('discount')>0.1 ? 0 : 1,
                discount2 = tour2.get('discount')>0.1 ? 0 : 1,
                price1 = tour1.get('priceWithOilTax'),
                price2 = tour2.get('priceWithOilTax');

            return this.compare([[price1, price2], [discount1, discount2]], model1, model2);
        },
        hotDown: function(model1, model2) {
            var tour1 = model1.get('tour'),
                tour2 = model2.get('tour'),
                discount1 =  tour1.get('discount')>0.1 ? 0 : 1,
                discount2 = tour2.get('discount')>0.1 ? 0 : 1,
                price1 = tour1.get('priceWithOilTax'),
                price2 = tour2.get('priceWithOilTax');

            return this.compare([[price1, price2], [-discount1, -discount2]], model1, model2);
        },
        operators: function(model1, model2, sortOperatorId) {
            var tour1 = model1.get('tour'),
                tour2 = model2.get('tour'),
                operator1 = tour1.get('operator').id,
                operator2 = tour2.get('operator').id,
                price1 = tour1.get('priceWithOilTax'),
                price2 = tour2.get('priceWithOilTax');

            operator1 = operator1 == sortOperatorId ? 0 : 1;
            operator2 = operator2 == sortOperatorId ? 0 : 1;

            return this.compare([[price1, price2], [operator1, operator2]], model1, model2);
        },
        roomTypes: function(model1, model2, sortRoomTypeName) {
            var tour1 = model1.get('tour'),
                tour2 = model2.get('tour'),
                roomType1 = tour1.get('room').name,
                roomType2 = tour2.get('room').name,
                price1 = tour1.get('priceWithOilTax'),
                price2 = tour2.get('priceWithOilTax');

            roomType1 = roomType1 == sortRoomTypeName ? 0 : 1;
            roomType2 = roomType2 == sortRoomTypeName ? 0 : 1;

            return this.compare([[price1, price2], [roomType1, roomType2]], model1, model2);
        },
		airLines: function(model1, model2, sortAirLineName) {
			var tour1 = model1.get('tour')?model1.get('tour'):null,
				tour2 = model2.get('tour')?model2.get('tour'):null,
				route1 = (tour1)?tour1.get('routes')[0]:null,
				route2 = (tour2)?tour2.get('routes')[0]:null,
				there1 = (route1)?route1.there:null,
				there2 = (route2)?route2.there:null,
				leg1 = (there1)?there1.legs[0]:null,
				leg2 = (there2)?there2.legs[0]:null,
				airLine1 = (leg1)?leg1.airline:null,
				airLine2 = (leg2)?leg2.airline:null,
				airLineName1 = (airLine1)?airLine1.name:'Уточнить авиакомпанию',
				airLineName2 = (airLine2)?airLine2.name:'Уточнить авиакомпанию';

			airLineName1 = airLineName1 == sortAirLineName ? 0 : 1;
			airLineName2 = airLineName2 == sortAirLineName ? 0 : 1;

			return this.compare([{field:'finalPrice'}, [airLineName1, airLineName2]], model1, model2);
		}
    }
});

export default TourProductsSortedRepository;